import '../../../util/array';
import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Button, Checkbox, FormControlLabel, Grid, Snackbar, CircularProgress } from '@material-ui/core';
import NewPatientPhoto from './NewPatientPhoto';
import { useLang } from '../../../util/lang';
import { useSelector, useDispatch } from 'react-redux';
import { NEW_PATIENT_FILE_SHORTCUT } from '../../../store/NewPatient/actionType';
import { ThreeShapeClientId, ThreeShapeConnectUrl, ThreeShapeRedirectUrl } from '../../../config.json';
import axios from '../../../axios-default';
import Modal from '../../Modal/modal';
import Moment from 'moment/moment';
import Zip from 'jszip';
import FileSaver from 'file-saver';
import GetAppIcon from '@material-ui/icons/GetApp';
import { getWebAbsPath } from '../../../util/path';
import { ApiServerUrl } from '../../../config.json';
import { safeGetWithProgress } from '../../../axios-default';
import { easySnackbar } from '../../../store/Noti/noti.actions';
import PercentageProgressRing from '../../PercentageProgressRing';
import MuiAlert from '@material-ui/lab/Alert';
import { WIN_STATUS, fetchConnectPlatformData, openWin } from '../../../store/ConnectPlatform/connectPlatform';
import useOAuthConnectPlatform, {
    BASE_CASE_RES,
    OAUTH_BTN_ICON_MAP,
    oAuthModalInitialState,
} from '../../../hooks/useOAuthConnectPlatform';
import useWebSocketManagerForOAuth from '../../../hooks/useWebSocketManagerForOAuth';
import ConnectedPlatformModal from './ConnectedPlaform/ConnectedPlatformModal';
import { NewPatientFiles } from '../../../store/NewPatient/type';
import { ConnectedPlaformState, PlatformInfo } from '../../../model/oauth/medictLink_type';
import {
    defaultFileName,
    upperFileName,
    lowerFileName,
    biteOneFileName,
    biteTwoFileName,
    stlTypeOptions,
} from './StlImpression_util';
import CachedIcon from '@material-ui/icons/Cached';
import { ConnectPlatformGrid, CustomConnectButton } from './StlImpressionComponent';
import { PLATFORM_TYPE } from '../../../model/oauth/type';
import { logOut } from '../../../store/Auth/Auth.action';
import { openModal } from '../../../store/Global/global';

const MIN_FILE_SIZE = 100 * 1024; // 100kb

const serverLabel = {
    globalServer: 'Global Server',
    euServer: 'European Server',
    nonEuServer: 'Non-European Server',
};

const StlImpression = (props) => {
    const get = useLang('NewPatient');
    const getPatientInfo = useLang('PatientInfo');
    const {
        disconnectPlatform,
        modal,
        setModal,
        getPlatformDisplayName,
        getCasesByPlatform,
        oauthLoading,
        selectedOAuthStlTypes,
        setSelectedOAuthStlTypes,
        searchCases,
        showMoreRecord,
        validateOAuthSelectNecessaryStl,
        getOAuthFileDownloadUrl,
    } = useOAuthConnectPlatform();
    const { initConnection, setOAuthWindow, oAuthWindow } = useWebSocketManagerForOAuth();

    const dispatch = useDispatch();
    const { files: storeFiles, connectPlatformDataList } = useSelector((store) => ({
        /**
         * @type {NewPatientFiles[]}
         */
        files: store.newPatientReducer.files,
        /**
         * the state of ConnectedPlatform that save in store
         * @type {ConnectedPlaformState}
         */
        connectPlatformDataList: store.connectPlatformReducer,
    }));
    const files = props.files || storeFiles;
    const fileSlots = props.fileSlots || {
        upper: 'impression_upper',
        lower: 'impression_lower',
        bite: 'impression_scan_one',
        biteTwo: 'impression_scan_two',
    };

    const { isLoading: isConnectPlatformLoading } = connectPlatformDataList;

    /** Returns whether all active STL fields are marked for later upload. */
    const isUploadLater = () =>
        Object.values(fileSlots)
            .filter(Boolean)
            .every((id) => files.find((file) => file.id === id)?.upload_later);

    /** Returns whether any active STL field has an uploaded file. */
    const hasUploadedImpressions = () => {
        const impressionIds = Object.values(fileSlots).filter(Boolean);
        return impressionIds.some(id => props.imageUploaded(id));
    };

    const setUploadLater = (bFlag) => {
        ['impression_upper', 'impression_lower', 'impression_scan_one', 'impression_scan_two'].asyncForEach((id) =>
            dispatch({
                type: NEW_PATIENT_FILE_SHORTCUT,
                subtype: 'upload_later',
                id,
                value: bFlag,
            })
        );
    };

    const [threeShapeList, setThreeShapeList] = useState([]);
    const [totalCase, setTotalCase] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingPage, setLoadingPage] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [searchString, setSearchString] = useState('');
    const [selectedStl, setSelectedStl] = useState([]);
    const [selectedStlTypes, setSelectedStlTypes] = useState([]);
    const [downloadedBlobFiles, setDownloadedBlobFiles] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const progressBarRef = useRef(null);

    const threeShapeURLFormatter = (case_id, file_id) => {
        return `/threeshape/get_stl?case_id=${case_id}&file_id=${file_id}`;
    };

    const findTheMatchStlTypeFile = (stlType) => {
        const matchResult = downloadedBlobFiles.find((e) => e.stlType.value == stlType);
        if (matchResult != undefined) {
            const stlFile = new File([matchResult.file], matchResult.fileName);
            return stlFile;
        } else {
            return null;
        }
    };

    const openThreeShapeModel = () => {
        setModalOpen(true);
    };

    const closeThreeShapeModel = () => {
        if (selectedStlTypes.length > 0) {
            setSelectedStlTypes([]);
        }
        setModalOpen(false);
    };

    /**
     * Open PlatformModal
     * @type {(random_url:string , platformInfo:PlatformInfo) => void} open modal
     */
    const openPlatformModal = async (random_url, platformInfo) => {
        if (!platformInfo.connected) {
            // initConnection()
            const win = window.open(random_url);
            setOAuthWindow(win);
            dispatch(openWin());
        } else {
            setModal((draft) => {
                draft.title = getPlatformDisplayName(platformInfo.platform);
                draft.open = true;
                draft.platform = platformInfo.platform;
            });
            const res = await getCasesByPlatform(platformInfo.platform, { access_token: platformInfo.access_token });
            //  console.log("res", res)
            setModal((draft) => {
                draft.caseInfos = res && res.caseData ? res.caseData : [];
                draft.pageInfo = res && res.pageInfo ? res.pageInfo : BASE_CASE_RES.pageInfo;
                draft.access_token = platformInfo.access_token;
                draft.refresh_token = platformInfo.refresh_token;
            });
        }
        // further handling is placed in useWebSocketManagerForOAuth hook
    };

    const reloadPlatformModal = async () => {
        setModal((draft) => {
            draft.caseInfos = [];
            draft.pageInfo = BASE_CASE_RES.pageInfo;
        });
        const res = await getCasesByPlatform(modal.platform, { access_token: modal.access_token });
        setModal((draft) => {
            draft.caseInfos = res && res.caseData ? res.caseData : [];
            draft.pageInfo = res && res.pageInfo ? res.pageInfo : BASE_CASE_RES.pageInfo;
        });
    };

    useEffect(() => {
        if (connectPlatformDataList && connectPlatformDataList.oauthWindowStatus === WIN_STATUS.CLOSE) {
            if (oAuthWindow) {
                oAuthWindow.close();
            }
        }
    }, [connectPlatformDataList.oauthWindowStatus]);

    const searchRecord = async (page, text = '', retry = false) => {
        setLoadingPage(true);
        setCurrentPage(page);

        let { data } = await axios.get(`/threeshape/get_list?page=${page}&search=${text}`);
        if (data.success) {
            // successfully get data from API, remove message in red color, open modal, display records
            props.handleThreeshapeConnected(true);
            openThreeShapeModel();

            if (page) {
                // not 1st page, append to the list
                setThreeShapeList([...threeShapeList, ...data.case_list]);
            } else {
                // 1st page, replace data, clear selected stl list
                setThreeShapeList(data.case_list);
                setSelectedStl([]);
                setTotalCase(data.count);
            }
        } else if (!retry && data.message == 'connect') {
            var verifierInfo = await axios.get(`/threeshape/get_challenge`);
            if (verifierInfo && verifierInfo.data.success) {
                // no stored 3shape token, open new window for login
                var win = window.open(
                    `${ThreeShapeConnectUrl}/authorize?client_id=${ThreeShapeClientId}&response_type=code&scope=openid+api+offline_access+communicate.connections.manage+data.companies.read_only+data.users.read_only&redirect_uri=${ThreeShapeRedirectUrl}&code_challenge=${verifierInfo.data.challenge}&code_challenge_method=S256&response_mode=query`
                );

                // check every 10 seconds, if the 3shape token is found from DB
                var timer = setInterval(async () => {
                    let result = await axios.get(`/threeshape/check_connect`);
                    if (result && result.data.success) {
                        win.close();
                        clearInterval(timer);
                    }
                }, 5000);

                // check every 1 second, if the login window closes, stop checking and start this function again
                var timer2 = setInterval(function () {
                    if (win.closed) {
                        clearInterval(timer);
                        searchRecord(0, text, true); // retry = true prevents infinite loop of "user close window without login" and "auto open window"
                        clearInterval(timer2); // in case user close login window without login
                    }
                }, 1000);
            } else {
                alert('Fail to connect to 3Shape, please try again.');
            }
        } else {
            alert('Fail to connect to 3Shape, please try again.');
        }
        setLoadingPage(false);
    };

    const disconnect3Shape = async () => {
        // logout
        try {
            let { data } = await axios.post(`/threeshape/logout`);
            if (data.three_shape_token) {
                let token = data.three_shape_token;
                let win = window.open(
                    `${ThreeShapeConnectUrl}/endsession?id_token_hint=${token}&post_logout_redirect_uri=${window.location.origin}/threeshape_connect/1`
                );
                var timer = setInterval(() => {
                    if (win.location.pathname == '/threeshape_connect/1') {
                        win.close();
                        setThreeShapeList([]);
                        props.handleThreeshapeConnected(false);
                        clearInterval(timer);
                    }
                    if (win.closed) {
                        clearInterval(timer);
                    }
                }, 5000);
            }
        } catch (e) {
            clearInterval(timer);
            await dispatch(easySnackbar(e.message, 'error'));
        }
    };

    const handleSelectBoxSelectStlChange = (
        threeShapeCaseId,
        rowThreeShapeCaseFileId,
        rowThreeShapeCaseFileName,
        selectedValue
    ) => {
        const selectBoxSelectedStl = stlTypeOptions.find((ele) => ele.value == selectedValue);
        const caseFileStl = {
            stlType: selectBoxSelectedStl,
            caseId: threeShapeCaseId,
            fileId: rowThreeShapeCaseFileId,
            fileName: rowThreeShapeCaseFileName,
            url: threeShapeURLFormatter(threeShapeCaseId, rowThreeShapeCaseFileId),
        };
        let cloneSelectedStlTypes = [...selectedStlTypes];

        let matchSelectedStlTypeIndex = cloneSelectedStlTypes.findIndex(
            (e) => e.stlType.value == selectBoxSelectedStl.value
        );

        if (matchSelectedStlTypeIndex < 0) {
            cloneSelectedStlTypes = cloneSelectedStlTypes.filter(
                (e) =>
                    !(
                        e.caseId == threeShapeCaseId &&
                        e.fileId == rowThreeShapeCaseFileId &&
                        e.fileName == rowThreeShapeCaseFileName
                    )
            );
            if (selectBoxSelectedStl.value != defaultFileName) {
                cloneSelectedStlTypes.push(caseFileStl);
            }
        }
        setSelectedStlTypes(cloneSelectedStlTypes);
    };

    const isOptionDisabled = useMemo(() => {
        return (optionVal) => {
            if (optionVal.value != defaultFileName) {
                return selectedStlTypes.findIndex((e) => e.stlType.value == optionVal.value) >= 0;
            } else {
                return false;
            }
        };
    }, [selectedStlTypes]);

    const isStlSelectBoxDisable = useMemo(() => {
        return selectedStl.length > 0;
    }, [selectedStl]);

    const isStlCheckBoxDisable = useMemo(() => {
        return selectedStlTypes.length > 0;
    }, [selectedStlTypes]);

    // search start after user stops typing for 2 seconds
    useEffect(() => {
        const delaySearch = setTimeout(() => {
            if (modalOpen) {
                searchRecord(0, searchString);
            }
        }, 2000);
        return () => clearTimeout(delaySearch);
    }, [searchString]);

    useEffect(() => {
        if (
            downloadedBlobFiles.length == selectedStlTypes.length &&
            selectedStlTypes.length != 0 &&
            downloadedBlobFiles.length != 0
        ) {
            const upperFile = findTheMatchStlTypeFile(upperFileName);
            const lowerFile = findTheMatchStlTypeFile(lowerFileName);
            const biteOneFile = findTheMatchStlTypeFile(biteOneFileName);
            const biteTwoFile = findTheMatchStlTypeFile(biteTwoFileName);

            props.handleChange(fileSlots.upper, upperFile);
            props.handleChange(fileSlots.lower, lowerFile);
            props.handleChange(fileSlots.bite, biteOneFile);
            if (biteTwoFile != null && !props.hideBiteTwo && fileSlots.biteTwo) {
                props.handleChange(fileSlots.biteTwo, biteTwoFile);
            }
            closeThreeShapeModel();
        }
    }, [downloadedBlobFiles]);

    // const handleSelectStl = (case_id, file_id, checked) => {
    //   let url, file_name
    //   let case_list = threeShapeList.map(v => {
    //     return v.case_id == case_id ? {
    //       ...v,
    //       files: v.files.map(f => {
    //         if (f.file_id == file_id) {
    //           url = threeShapeURLFormatter(case_id, file_id);
    //           file_name = f.case_name
    //           return {
    //             ...f,
    //             checked
    //           }
    //         } else {
    //           return f
    //         }
    //       })
    //     } : v
    //   })
    //   setThreeShapeList(case_list)

    //   if (checked) {
    //     if (url && file_name) {
    //       setSelectedStl([...selectedStl, {url, file_name}])
    //     }
    //   } else {
    //     setSelectedStl(selectedStl.filter(v => v.url != url && v.file_name != file_name))
    //   }
    // }

    const downloadStl = async () => {
        try {
            setLoadingPage(true);
            if (!selectedStl.length) {
                throw new Error('No file selected');
            }
            const zipFile = new Zip();
            let loaded = [],
                total = [];
            const promises = await Promise.allSettled(
                selectedStl.map((file, i) =>
                    safeGetWithProgress(
                        { baseURL: ApiServerUrl, url: file.url, responseType: 'blob' },
                        ({ loaded: _loaded, total: _total }) => {
                            loaded[i] = _loaded;
                            total[i] = _total;
                            progressBarRef.current.onProgressChange({
                                loaded: loaded.reduce((a, v) => a + v, 0),
                                total: total.reduce((a, v) => a + v, 0),
                            });
                        }
                    )
                )
            );
            if (promises.some(({ status }) => status !== 'fulfilled')) {
                await dispatch(easySnackbar('Cannot get some of the files', 'error'));
                return;
            } else {
                promises.forEach(({ value }, i) => {
                    zipFile.file(selectedStl[i].file_name, value);
                });
            }
            FileSaver.saveAs(
                await zipFile.generateAsync({
                    type: 'blob',
                }),
                `3shape_stl_${Moment().format('YYYYMMDDHHmmss')}.zip`
            );
        } catch (err) {
            await dispatch(easySnackbar(err.message, 'error'));
        } finally {
            setLoadingPage(false);
        }
    };

    const downloadSelectedBoxStl = async () => {
        try {
            setDownloadedBlobFiles([]);
            setLoadingPage(true);
            validateSelectNecessaryStl(selectedStlTypes);
            let loaded = [],
                total = [];
            const promises = await Promise.allSettled(
                selectedStlTypes.map((file, i) =>
                    safeGetWithProgress(
                        { baseURL: ApiServerUrl, url: file.url, responseType: 'blob' },
                        ({ loaded: _loaded, total: _total }) => {
                            loaded[i] = _loaded;
                            total[i] = _total;
                            progressBarRef.current.onProgressChange({
                                loaded: loaded.reduce((a, v) => a + v, 0),
                                total: total.reduce((a, v) => a + v, 0),
                            });
                        }
                    )
                )
            );
            if (promises.some(({ status }) => status !== 'fulfilled')) {
                await dispatch(easySnackbar('Cannot get some of the files', 'error'));
                return;
            } else {
                promises.forEach(({ value }, i) => {
                    try {
                        const downloadedFile = {
                            stlType: selectedStlTypes[i].stlType,
                            fileName: selectedStlTypes[i].fileName,
                            file: value,
                        };
                        setDownloadedBlobFiles((prevFiles) => [...prevFiles, downloadedFile]);
                    } catch (e) {
                        console.log(e);
                    }
                });
            }
        } catch (err) {
            await dispatch(easySnackbar(err.message, 'error'));
        } finally {
            setLoadingPage(false);
        }
    };

    const validateSelectNecessaryStl = (stlFiles) => {
        let msgArray = [];
        const hasUpper = stlFiles.some((item) => item.stlType.value == upperFileName);
        const hasLower = stlFiles.some((item) => item.stlType.value == lowerFileName);
        const hasBiteOne = stlFiles.some((item) => item.stlType.value == biteOneFileName);

        if (!hasUpper) {
            msgArray.push(upperFileName);
        }
        if (!hasLower) {
            msgArray.push(lowerFileName);
        }
        if (!hasBiteOne) {
            msgArray.push(biteOneFileName);
        }

        if (msgArray.length > 0) {
            throw new Error(`Please select file: ${msgArray.join(', ')}`);
        }
    };

    const autoFillInSelectStlType = (caseId, fileId, fileName) => {
        const matchIndex = selectedStlTypes.findIndex(
            (selected) => selected.caseId == caseId && selected.fileId == fileId && selected.fileName == fileName
        );
        if (matchIndex >= 0) {
            return selectedStlTypes[matchIndex].stlType.value;
        } else {
            return defaultFileName;
        }
    };

    const isBelowMinFileSize = (file) => {
        if (file && file.size) {
            return file.size <= MIN_FILE_SIZE; // 100kb
        }
        return true; // return true if !file
    };

    const handleDragAndDropOnChange = (image_id, file) => {
        file !== 'remove' && isBelowMinFileSize(file) ? setSnackbarOpen(true) : props.handleChange(image_id, file); // ignore checking if file action is remove file
    };

    const getServerLabel = (platform, connected = false) => {
        const suffix = connected ? ' - Connected' : '';
        let serverDisplayLabel = '';
        switch (platform) {
            case PLATFORM_TYPE.MeditLink:
            case PLATFORM_TYPE.threeShape:
                serverDisplayLabel = serverLabel.globalServer + suffix;
                break;
            case PLATFORM_TYPE.PandaCloud_EU:
                // return <i>{serverLabel.euServer + suffix}</i>;
                return serverLabel.euServer + suffix;
            case PLATFORM_TYPE.PandaCloud_EN:
                serverDisplayLabel = serverLabel.nonEuServer + suffix;
                break;
            default:
                serverDisplayLabel += suffix;
                break;
        }
        return serverDisplayLabel;
    };

    const getScannerLabel = (platform) => {
        const scanner = ' scanner';
        switch (platform) {
            case PLATFORM_TYPE.MeditLink:
                return 'MEDIT' + scanner;
            case PLATFORM_TYPE.PandaCloud_EU:
            case PLATFORM_TYPE.PandaCloud_EN:
                return 'ELETRA SMART' + scanner;
            case PLATFORM_TYPE.threeShape:
                return '3Shape' + scanner;
            default:
                return scanner;
        }
    };

    return (
        <>
            <ConnectedPlatformModal
                modal={modal}
                open={modal.open}
                onClose={() => setModal(oAuthModalInitialState)}
                loading={oauthLoading}
                platform={modal.platform}
                setDownloadedBlobFiles={setDownloadedBlobFiles}
                handleFileToImpression={props.handleChange}
                fileSlots={fileSlots}
                selectedOAuthStlTypes={selectedOAuthStlTypes}
                setSelectedOAuthStlTypes={setSelectedOAuthStlTypes}
                searchCases={searchCases}
                showMoreRecord={showMoreRecord}
                validateOAuthSelectNecessaryStl={validateOAuthSelectNecessaryStl}
                reload={reloadPlatformModal}
                getOAuthFileDownloadUrl={getOAuthFileDownloadUrl}
            />
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <MuiAlert onClose={handleClose} severity="error" variant="filled" sx={{ width: '100%' }}>
                    {/* {`Please upload from unzipped folders only. Files must be >100KB.`} */}
                    {get('impressions.uploadImpressionWarning')}
                </MuiAlert>
            </Snackbar>
            <Grid item xs={12} style={{ margin: '20px 0px' }}>
                <h2>Scanner Integrations - Get connected and upload STL files seamlessly</h2>
            </Grid>
            <Grid container spacing={1}>
                {['INTERNATIONAL'].includes(process.env.REACT_APP_ENV) &&
                    ['DR'].includes(JSON.parse(localStorage.getItem('role'))) && (
                        <>
                            {isConnectPlatformLoading && (
                                <Grid item xs={12} style={{ display: 'grid', placeItems: 'center' }}>
                                    <CircularProgress color="secondary" />
                                </Grid>
                            )}
                            {!isConnectPlatformLoading &&
                                connectPlatformDataList &&
                                connectPlatformDataList.data.length > 0 &&
                                connectPlatformDataList.data.map((platformInfo, index) => {
                                    return (
                                        <ConnectPlatformGrid
                                            key={index}
                                            imgProps={{
                                                src: getWebAbsPath(OAUTH_BTN_ICON_MAP[platformInfo.platform]),
                                                alt: `${platformInfo.platform} Logo`,
                                                height: '40px',
                                            }}
                                            scannerLabel={getScannerLabel(platformInfo.platform)}
                                            serverLabel={getServerLabel(platformInfo.platform, platformInfo.connected)}
                                            connected={platformInfo.connected}
                                            openPlatformModal={() =>
                                                openPlatformModal(platformInfo.generate_url, platformInfo)
                                            }
                                            disconnectPlatform={async () => {
                                                await disconnectPlatform(platformInfo.connect_platform_id);
                                                dispatch(fetchConnectPlatformData());
                                            }}
                                        />
                                    );
                                })}

                            {!isConnectPlatformLoading && (
                                <ConnectPlatformGrid
                                    imgProps={{
                                        src: getWebAbsPath('/img/button_3shape.png'),
                                        alt: '3 Shape Logo',
                                        height: '40px',
                                    }}
                                    key={PLATFORM_TYPE.threeShape}
                                    scannerLabel={getScannerLabel(PLATFORM_TYPE.threeShape)}
                                    serverLabel={getServerLabel(PLATFORM_TYPE.threeShape, props.threeshapeConnected)}
                                    connected={props.threeshapeConnected}
                                    openPlatformModal={() => searchRecord(0)}
                                    disconnectPlatform={() => disconnect3Shape()}
                                />
                            )}

                            {['INTERNATIONAL'].includes(process.env.REACT_APP_ENV) &&
                                ['DR'].includes(JSON.parse(localStorage.getItem('role'))) &&
                                !isConnectPlatformLoading && (
                                    <Grid item xs={8} style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                        <p style={{ fontSize: 20 }}>
                                            {getPatientInfo('OAuth.ReloadPlatformMessage')}
                                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <Button
                                                    onClick={() => {
                                                        try {
                                                            dispatch(fetchConnectPlatformData());
                                                        } catch (error) {
                                                            if (error.response && error.response.status === 401) {
                                                                dispatch(
                                                                    openModal({
                                                                        modalTitle: 'Login session expired',
                                                                        modalMessage: 'Please login again',
                                                                        modalCallbackFunc: () => dispatch(logOut()),
                                                                        showClose: false,
                                                                    })
                                                                );
                                                            } else {
                                                                const errorMessage =
                                                                    error.response?.data?.message ||
                                                                    error.message ||
                                                                    'An unknown error occurred, please try refresh page';
                                                                dispatch(easySnackbar(errorMessage, 'error'));
                                                            }
                                                        }
                                                    }}
                                                    variant="contained"
                                                    // startIcon={<CachedIcon />}
                                                    color="secondary"
                                                    disabled={isConnectPlatformLoading}
                                                // fullWidth
                                                >
                                                    {getPatientInfo('OAuth.ReloadPlatform')}
                                                </Button>
                                            </div>
                                        </p>
                                    </Grid>
                                )}
                        </>
                    )}

                <Grid item xs={12}>
                    <h2>Manually Upload</h2>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <li>
                        <NewPatientPhoto
                            mode={props.mode}
                            imageId={fileSlots.upper}
                            imageUploaded={props.imageUploaded(fileSlots.upper)}
                            imageData={props.imageData(fileSlots.upper)}
                            imageName="imageUpload.png"
                            type="impression"
                            StlLabel={
                                get('impressions.upper_stl') !== 'N/A' ? get('impressions.upper_stl') : 'Upper STL'
                            }
                            StlWillNotUploadLabel={get('impressions.notUploadWarning')}
                            upload_without_STLfile={isUploadLater()}
                            handleChange={(file) => {
                                handleDragAndDropOnChange(fileSlots.upper, file);
                            }}
                        />
                    </li>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <li>
                        <NewPatientPhoto
                            mode={props.mode}
                            imageId={fileSlots.lower}
                            imageUploaded={props.imageUploaded(fileSlots.lower)}
                            imageData={props.imageData(fileSlots.lower)}
                            imageName="imageUpload.png"
                            type="impression"
                            StlLabel={
                                get('impressions.lower_stl') != 'N/A' ? get('impressions.lower_stl') : 'Lower STL'
                            }
                            StlWillNotUploadLabel={get('impressions.notUploadWarning')}
                            upload_without_STLfile={isUploadLater()}
                            handleChange={(file) => {
                                handleDragAndDropOnChange(fileSlots.lower, file);
                            }}
                        />
                    </li>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <li>
                        <NewPatientPhoto
                            mode={props.mode}
                            imageId={fileSlots.bite}
                            imageUploaded={props.imageUploaded(fileSlots.bite)}
                            imageData={props.imageData(fileSlots.bite)}
                            imageName="imageUpload.png"
                            type="impression"
                            StlLabel={
                                get('impressions.bite_1_stl') != 'N/A' ? get('impressions.bite_1_stl') : 'Bite 1 STL'
                            }
                            StlWillNotUploadLabel={get('impressions.notUploadWarning')}
                            upload_without_STLfile={isUploadLater()}
                            handleChange={(file) => {
                                handleDragAndDropOnChange(fileSlots.bite, file);
                            }}
                        />
                    </li>
                </Grid>
                {!props.hideBiteTwo && fileSlots.biteTwo && <Grid item xs={12} sm={3}>
                    <li>
                        <NewPatientPhoto
                            mode={props.mode}
                            imageId={fileSlots.biteTwo}
                            imageUploaded={props.imageUploaded(fileSlots.biteTwo)}
                            imageData={props.imageData(fileSlots.biteTwo)}
                            imageName="imageUpload.png"
                            type="impression"
                            StlLabel={
                                get('impressions.bite_2_stl') != 'N/A'
                                    ? get('impressions.bite_2_stl')
                                    : 'Bite 2 STL (optional)'
                            }
                            StlWillNotUploadLabel={get('impressions.notUploadWarning')}
                            upload_without_STLfile={isUploadLater()}
                            handleChange={(file) => {
                                handleDragAndDropOnChange(fileSlots.biteTwo, file);
                            }}
                        />
                    </li>
                </Grid>}

                {/* {props.uploadLater &&
                    props.mode !== 'view' &&
                    !['impression_upper', 'impression_lower', 'impression_scan_one', 'impression_scan_two'].every(
                        (id) => {
                            const targetFile = files.find((file) => file.id === id)?.data;
                            return typeof targetFile === 'object';
                        }
                    ) && (
                        <>
                            <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'center', marginTop: '4%' }}>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox checked={isUploadLater()} />}
                                    label={get('impressions.uploadStlFilesLater')}
                                    labelPlacement="end"
                                    // onChange={() => handleNoImage()}
                                    onChange={() => setUploadLater(!isUploadLater())}
                                />
                            </Grid>
                        </>
                    )} */}

                {props.uploadLater && (
                    <>
                        <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'center', marginTop: '4%' }}>
                            <FormControlLabel
                                value="end"
                                control={<Checkbox checked={isUploadLater()} />}
                                label={get('impressions.uploadStlFilesLater')}
                                labelPlacement="end"
                                disabled={hasUploadedImpressions()}
                                // onChange={() => handleNoImage()}
                                onChange={() => setUploadLater(!isUploadLater())}
                            />
                        </Grid>
                    </>
                )}

            </Grid>

            <Modal
                title="3Shape STL List"
                open={modalOpen}
                handleClose={() => closeThreeShapeModel()}
                submitButton={false}
                optBtn={{
                    key: '3shapeSelectAndAutoFillIn',
                    label: getPatientInfo('OAuth.Modal.SelectedAndAutoFillIn'),
                    icon: <GetAppIcon />,
                    onClick: downloadSelectedBoxStl,
                    disabled: loadingPage,
                }}
            >
                <PercentageProgressRing ref={progressBarRef} open={loadingPage} />
                <input
                    type="text"
                    value={searchString ?? ''}
                    onChange={(e) => setSearchString(e.target.value)}
                    placeholder={getPatientInfo('OAuth.Modal.Search')}
                    style={{
                        width: 'calc(100% - 6px)',
                        fontSize: 17,
                        border: 'solid 1px rgba(89,54,135,1)',
                        height: 32,
                    }}
                />

                {threeShapeList.length ? (
                    <Grid container style={{ overflowWrap: 'break-word' }}>
                        <Grid item xs={2} style={{ border: '1px solid grey' }}>
                            {getPatientInfo('OAuth.Modal.Status')}
                        </Grid>
                        <Grid item xs={2} style={{ border: '1px solid grey' }}>
                            {getPatientInfo('OAuth.Modal.PatientName')}
                        </Grid>
                        <Grid item xs={8}>
                            <Grid container>
                                <Grid item xs={7} style={{ border: '1px solid grey' }}>
                                    {getPatientInfo('OAuth.Modal.CaseName')}
                                </Grid>
                                <Grid item xs={3} style={{ border: '1px solid grey' }}>
                                    {getPatientInfo('OAuth.Modal.CreatedDate')}
                                </Grid>
                                {/* <Grid item xs={1} style={{ border: "1px solid grey" }}>
              </Grid> */}
                                <Grid item xs={2} style={{ border: '1px solid grey' }}>
                                    {getPatientInfo('OAuth.Modal.Select')} Stl Type
                                </Grid>
                            </Grid>
                        </Grid>

                        {threeShapeList.map((v) => (
                            <>
                                <Grid item xs={2} style={{ border: '1px solid grey' }}>
                                    {v.status}
                                </Grid>
                                <Grid item xs={2} style={{ border: '1px solid grey' }}>
                                    {v.patient_name}
                                </Grid>
                                <Grid item xs={8}>
                                    {v.files.map((f) => (
                                        <Grid container>
                                            <Grid item xs={7} style={{ border: '1px solid grey' }}>
                                                {f.case_name}
                                            </Grid>
                                            <Grid item xs={3} style={{ border: '1px solid grey' }}>
                                                {Moment(v.created_date).format('YYYY-MM-DD HH:mm')}
                                            </Grid>
                                            {/* <Grid item xs={1} style={{ border: "1px solid grey", textAlign:"center" }}>
                    <Checkbox
                      disabled={isStlCheckBoxDisable}
                      checked={typeof(f.checked) == "boolean" ? f.checked : false}
                      onChange={(e) => handleSelectStl(v.case_id, f.file_id, e.target.checked)}
                    />
                  </Grid> */}
                                            <Grid
                                                item
                                                xs={2}
                                                style={{
                                                    border: '1px solid grey',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '10px',
                                                }}
                                            >
                                                <select
                                                    disabled={isStlSelectBoxDisable}
                                                    value={autoFillInSelectStlType(v.case_id, f.file_id, f.case_name)}
                                                    onChange={(e) =>
                                                        handleSelectBoxSelectStlChange(
                                                            v.case_id,
                                                            f.file_id,
                                                            f.case_name,
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    {stlTypeOptions.map((stlType, index) => (
                                                        <option
                                                            key={`${v.caseId}_${f.file_id}_stl_Select_${index}_${stlType.value}`}
                                                            value={stlType.value}
                                                            disabled={isOptionDisabled(stlType)}
                                                        >
                                                            {stlType.text}
                                                        </option>
                                                    ))}
                                                </select>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </Grid>
                            </>
                        ))}

                        <Grid item xs={9}>
                            {/* 3Shape only returns 10 records per each API calls */}
                            {totalCase == 0 || (currentPage + 1) * 10 >= totalCase || loadingPage || (
                                <>
                                    <Button
                                        variant="outlined"
                                        onClick={() => searchRecord(currentPage + 1, searchString)}
                                    >
                                        Show more records
                                    </Button>
                                </>
                            )}
                        </Grid>
                        <Grid item xs={3} style={{ textAlign: 'right' }}>
                            {/* {
              !isStlCheckBoxDisable && 
              <Button variant="outlined" onClick={() => downloadStl()} disabled={loadingPage}>
                Download <GetAppIcon />
              </Button>
            } */}
                            {/* {
              !isStlSelectBoxDisable &&
              <Button variant="outlined" onClick={() => downloadSelectedBoxStl()} disabled={loadingPage}>
                 {getPatientInfo('OAuth.Modal.SelectedAndAutoFillIn')} <GetAppIcon />
              </Button>
            } */}
                        </Grid>
                    </Grid>
                ) : (
                    ''
                )}
            </Modal>
        </>
    );
};

export default StlImpression;
